export default __webpack_public_path__ + "static/media/trash.55424711.svg";